export const paramSources = {
  postman: {
    canEditDataTypes: true,
    canEditKeyName: false,
    canAddDeleteParams: true,
    canSyncInputs: false,
  },
  openapi: {
    canEditDataTypes: false,
    canEditKeyName: false,
    canAddDeleteParams: true,
    canSyncInputs: false,
  },
  mssql: {
    canEditDataTypes: false,
    canEditKeyName: false,
    canAddDeleteParams: false,
    canSyncInputs: true,
  },
  postgres: {
    canEditDataTypes: false,
    canEditKeyName: false,
    canAddDeleteParams: false,
    canSyncInputs: true,
  },
  python_static_analysis: {
    canEditDataTypes: true,
    canEditKeyName: false,
    canAddDeleteParams: false,
    canSyncInputs: true,
  },
  r_static_analysis: {
    canEditDataTypes: true,
    canEditKeyName: false,
    canAddDeleteParams: true,
    canSyncInputs: true,
  },
  unavailable: {
    canEditDataTypes: true,
    canEditKeyName: true,
    canAddDeleteParams: true,
    canSyncInputs: false,
  },
  manual: {
    canEditDataTypes: true,
    canEditKeyName: true,
    canAddDeleteParams: true,
    canSyncInputs: false,
  },
} as const;

// TypeScript will automatically infer the exact type from the `as const`
export type ParamSources = typeof paramSources;
